<template>
  <div class="back" @click="handleback">
    <svg
      t="1706153298835"
      class="icon"
      viewBox="0 0 2701 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2618"
      width="100%"
      height="100%"
    >
      <path
        d="M1856.232727 681.425455h338.850909V342.574545H1856.232727v338.85091z m70.749091-262.516364c13.032727 1.861818 26.065455 1.861818 52.130909 1.861818H2066.618182c24.203636 0 39.098182 0 52.130909-1.861818-1.861818 11.170909-1.861818 20.48-1.861818 37.236364v107.985454c0 18.618182 0 26.065455 1.861818 37.236364-14.894545-1.861818-27.927273-1.861818-52.130909-1.861818h-87.505455c-27.927273 0-37.236364 0-52.130909 1.861818 1.861818-11.170909 1.861818-22.341818 1.861818-37.236364v-107.985454c0-16.756364 0-26.065455-1.861818-37.236364z"
        fill="#ffffff"
        p-id="2619"
      />
      <path
        d="M1960.494545 446.836364h124.741819v126.603636h-124.741819z"
        fill="#ffffff"
        p-id="2620"
      />
      <path
        d="M512 0C229.003636 0 0 229.003636 0 512S229.003636 1024 512 1024h2189.498182V0H512zM1470.836364 541.789091c5.585455-37.236364 9.309091-83.781818 9.309091-148.945455 0-37.236364-1.861818-65.163636-3.723637-81.92 7.447273 1.861818 11.170909 1.861818 18.618182 1.861819 48.407273 0 106.123636-3.723636 150.807273-9.309091 29.789091-3.723636 42.821818-5.585455 68.887272-13.032728l22.341819 29.789091c-3.723636 0-3.723636 0-20.48 3.723637-57.716364 9.309091-132.189091 14.894545-206.661819 16.756363v72.610909h156.392728c20.48 0 33.512727-1.861818 40.96-1.861818l16.756363 20.48c-3.723636 7.447273-7.447273 13.032727-13.032727 27.927273-16.756364 37.236364-31.650909 63.301818-55.854545 93.090909 33.512727 29.789091 55.854545 50.269091 78.196363 72.610909l-26.065454 22.341818c-20.48-22.341818-44.683636-46.545455-70.749091-72.610909-39.098182 40.96-72.610909 63.301818-124.741818 89.367273-9.309091-11.170909-13.032727-16.756364-22.341819-24.203636 55.854545-24.203636 85.643636-46.545455 124.741819-85.643637-29.789091-26.065455-44.683636-37.236364-80.058182-63.301818l22.341818-16.756364c35.374545 26.065455 52.130909 37.236364 76.334545 57.716364 24.203636-29.789091 37.236364-52.130909 52.13091-89.367273h-175.01091c-1.861818 102.4-16.756364 161.978182-55.854545 212.247273-9.309091-11.170909-11.170909-13.032727-24.203636-20.48 24.203636-35.374545 33.512727-59.578182 40.96-93.090909z m-137.774546-238.312727c33.512727 31.650909 53.992727 53.992727 78.196364 87.505454l-24.203637 22.341818c-24.203636-37.236364-46.545455-61.44-76.334545-89.367272l22.341818-20.48zM1055.44404 764.172929s-5.792323 14.894545-13.446464 0c0 0-85.643636-258.37899-294.374142-193.215353v80.26505s-3.309899 47.166061-44.476767 16.342627l-205.213738-177.079596s-43.442424-23.58303 2.689293-56.061415l207.282424-178.113939s31.237172-22.134949 38.684445 14.273939l0.206869 86.471112c0.206869 0 389.12 18.618182 308.64808 407.117575z m692.803233-45.511111c-94.952727 1.861818-113.570909 3.723636-186.181818 3.723637-80.058182 0-119.156364-9.309091-148.945455-37.236364-14.894545-13.032727-16.756364-14.894545-24.203636-14.894546-9.309091 0-26.065455 11.170909-50.269091 33.512728-7.447273 5.585455-13.032727 14.894545-18.618182 20.48l-22.341818-26.065455c5.585455-3.723636 7.447273-5.585455 16.756363-13.032727 27.927273-24.203636 50.269091-39.098182 63.301819-40.96v-126.603636h-31.65091c-16.756364 0-24.203636 0-35.374545 1.861818v-33.512728c11.170909 1.861818 18.618182 1.861818 37.236364 1.861819h26.065454c14.894545 0 26.065455 0 37.236364-1.861819-1.861818 14.894545-1.861818 27.927273-1.861818 52.13091v107.985454h-1.861819c7.447273 3.723636 7.447273 3.723636 27.927273 22.341818s59.578182 24.203636 147.083637 24.203637c70.749091 0 132.189091-3.723636 176.872727-9.309091-5.585455 13.032727-9.309091 22.341818-11.170909 35.374545z m482.210909 18.618182h-37.236364v-27.927273H1856.232727v29.789091h-35.374545c1.861818-14.894545 3.723636-29.789091 3.723636-59.578182V372.363636c0-24.203636-1.861818-42.821818-3.723636-61.44 18.618182 1.861818 31.650909 1.861818 57.716363 1.861819h292.305455c26.065455 0 40.96 0 59.578182-1.861819-1.861818 18.618182-3.723636 35.374545-3.723637 61.44v307.2c0 27.927273 1.861818 46.545455 3.723637 57.716364z"
        fill="#ffffff"
        p-id="2621"
      />
    </svg>
  </div>
</template>

<script>
// import {
//   fightRoomExit, //退出房间
// } from "@/api/index";
export default {
  props: ["from", "fightId"],
  methods: {
    playAudio(){
      this.$store.commit("playAudio");
    },
    handleback() {
      this.playAudio()
      // if (this.from == "pkHome") {
      //   fightRoomExit({ fightId: this.fightId }).then((res) => {
      //     console.log("fightRoomExit", res);
      //   });
      // }
      this.$router.back(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  width: 56px;
  height: 21px;
  @media (max-width: 550px) {
    width: 40px;
    height: 15px;
  }
}
</style>
